<ng-template #projectedContent>
  <ng-content></ng-content>
</ng-template>

<div class="card shadow-none ss-l-fake-page-wrapper" *ngIf="isAdmin; else plainContent">
  <div class="ss-l-fake-page-block-before">
    <!-- Navbar -->
    <div class="flex align-items-center justify-content-between mb-4">
      <p-skeleton shape="rectangle" width="110px" height="28px"></p-skeleton>
      <div style="display: flex; gap: 1.5rem;">
        <p-skeleton width="48px" height="12px"></p-skeleton>
        <p-skeleton width="48px" height="12px"></p-skeleton>
        <p-skeleton width="48px" height="12px"></p-skeleton>
        <p-skeleton width="48px" height="12px"></p-skeleton>
      </div>
    </div>

    <!-- Hero banner -->
    <p-skeleton shape="rectangle" width="100%" height="200px" styleClass="mb-4"></p-skeleton>
  </div>

  <ng-container *ngTemplateOutlet="projectedContent"></ng-container>

  <div class="ss-l-fake-page-block-title-grid">
    <!-- Título de seção -->
    <p-skeleton width="35%" height="22px" styleClass="mb-3 mt-4"></p-skeleton>

    <!-- Grid de produtos -->
    <div style="display: flex; gap: 1rem; margin-bottom: 1.5rem;">
      <div style="flex: 1; min-width: 0;">
        <p-skeleton shape="rectangle" width="100%" height="110px" styleClass="mb-2"></p-skeleton>
        <p-skeleton width="80%" height="12px" styleClass="mb-1"></p-skeleton>
        <p-skeleton width="45%" height="12px"></p-skeleton>
      </div>
      <div style="flex: 1; min-width: 0;">
        <p-skeleton shape="rectangle" width="100%" height="110px" styleClass="mb-2"></p-skeleton>
        <p-skeleton width="80%" height="12px" styleClass="mb-1"></p-skeleton>
        <p-skeleton width="45%" height="12px"></p-skeleton>
      </div>
      <div style="flex: 1; min-width: 0;">
        <p-skeleton shape="rectangle" width="100%" height="110px" styleClass="mb-2"></p-skeleton>
        <p-skeleton width="80%" height="12px" styleClass="mb-1"></p-skeleton>
        <p-skeleton width="45%" height="12px"></p-skeleton>
      </div>
    </div>
  </div>

  <div class="ss-l-fake-page-block-after">
    <p-skeleton width="30%" height="20px" styleClass="mb-3 mt-4"></p-skeleton>

    <!-- Colunas de rodapé -->
    <div style="display: flex; gap: 2rem;">
      <div style="flex: 1; min-width: 0;">
        <p-skeleton width="70%" height="14px" styleClass="mb-2"></p-skeleton>
        <p-skeleton width="90%" height="10px" styleClass="mb-1"></p-skeleton>
        <p-skeleton width="80%" height="10px" styleClass="mb-1"></p-skeleton>
        <p-skeleton width="60%" height="10px"></p-skeleton>
      </div>
      <div style="flex: 1; min-width: 0;">
        <p-skeleton width="70%" height="14px" styleClass="mb-2"></p-skeleton>
        <p-skeleton width="90%" height="10px" styleClass="mb-1"></p-skeleton>
        <p-skeleton width="80%" height="10px" styleClass="mb-1"></p-skeleton>
        <p-skeleton width="60%" height="10px"></p-skeleton>
      </div>
      <div style="flex: 1; min-width: 0;">
        <p-skeleton width="70%" height="14px" styleClass="mb-2"></p-skeleton>
        <p-skeleton width="90%" height="10px" styleClass="mb-1"></p-skeleton>
        <p-skeleton width="80%" height="10px" styleClass="mb-1"></p-skeleton>
        <p-skeleton width="60%" height="10px"></p-skeleton>
      </div>
    </div>

    <div style="display: flex; gap: 0.5rem; margin-top: 1.5rem;">
      <p-skeleton shape="circle" size="36px"></p-skeleton>
      <p-skeleton shape="circle" size="36px"></p-skeleton>
      <p-skeleton shape="circle" size="36px"></p-skeleton>
    </div>

    <!-- Preenchimento extra pra não sobrar espaço em branco quando o widget real é curto -->
    <div style="display: flex; gap: 2rem; margin-top: 2rem;">
      <div style="flex: 1; min-width: 0;">
        <p-skeleton width="70%" height="14px" styleClass="mb-2"></p-skeleton>
        <p-skeleton width="90%" height="10px" styleClass="mb-1"></p-skeleton>
        <p-skeleton width="80%" height="10px" styleClass="mb-1"></p-skeleton>
        <p-skeleton width="60%" height="10px"></p-skeleton>
      </div>
      <div style="flex: 1; min-width: 0;">
        <p-skeleton width="70%" height="14px" styleClass="mb-2"></p-skeleton>
        <p-skeleton width="90%" height="10px" styleClass="mb-1"></p-skeleton>
        <p-skeleton width="80%" height="10px" styleClass="mb-1"></p-skeleton>
        <p-skeleton width="60%" height="10px"></p-skeleton>
      </div>
      <div style="flex: 1; min-width: 0;">
        <p-skeleton width="70%" height="14px" styleClass="mb-2"></p-skeleton>
        <p-skeleton width="90%" height="10px" styleClass="mb-1"></p-skeleton>
        <p-skeleton width="80%" height="10px" styleClass="mb-1"></p-skeleton>
        <p-skeleton width="60%" height="10px"></p-skeleton>
      </div>
    </div>
  </div>
</div>
<ng-template #plainContent>
  <ng-container *ngTemplateOutlet="projectedContent"></ng-container>
</ng-template>
